import { WebProtegeActions } from './WebProtegeActions'

/** Описание элементов в OWL 
 * description содержит информацию о графах. Для элементов графа фиксируется триплет
*/

const initialWebProtegeState = {
    state: "empty",
    project: {},
}
export const webprotege = (state = { ...initialWebProtegeState} , action) => {
  switch (action.type) {
    case "WebProtegeActions.EMPTY":
      return{
        ...initialWebProtegeState,
      };
    case "WebProtegeActions.LOAD_STARTED":
      return{
        ...state,
        state: "load",
    };
    case "WebProtegeActions.LOAD_ERROR":
      return {
        ...initialWebProtegeState,
        error: action.error,
        state: "error",
    };
    case "WebProtegeActions.CREATE_PROJECT":
      return {
        ...state,
        projectDescription: action.projectDescription,
        state: "loaded",
    };    
    default:
      return state;
  }
}
